import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/global-error.tsx");
